import { IsoDateCodec } from '@/pages/OperationsAdministration/types/Api/IsoDateCodec';
import z from 'zod';

export const WorkstreamDefinitionOperationConfigPatchSchema = z.object({
    backlogEffectiveFrom: z.optional(IsoDateCodec),
    advancedSnapshot: z.optional(z.object({ isEnabled: z.optional(z.boolean()) }))
});
export type WorkstreamDefinitionOperationConfigPatch = z.infer<typeof WorkstreamDefinitionOperationConfigPatchSchema>;
